function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowCircleRightFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 1a15 15 0 100 30 15 15 0 000-30zm7.5 15.03a1.201 1.201 0 01-.354.87l-4.938 4.923a1.207 1.207 0 11-1.71-1.707l2.892-2.895H9.7a1.2 1.2 0 110-2.4h9.717l-2.919-2.919a1.21 1.21 0 111.71-1.71l4.938 4.923a1.198 1.198 0 01.354.855v.06z",
    fill: props.color
  }));
}

export default SvgIconArrowCircleRightFilled;